export default __webpack_public_path__ + "static/media/gl-17.4d9055f8.png";